import { RootState } from "../../store";

export const selectRedirect403 = (state: RootState) => state.redirect;